// @ts-nocheck TODO

import {html, LitElement} from "lit";
import {customElement, property} from "lit/decorators.js";
import {iconStyles} from "./styles/Icons.js";
import "./controls-inputs/IconButton.js";
import {annotationUuid} from "../../main/data/model/index.js";

@customElement("pn-citation-button")
export class CitationButton extends LitElement {
	@property() annotation = {
		type:       "",
		ai:         false,
		renderable: true,
		pageData:   null,
		citation:   null
	};
	// Whether this is clickable or not
	@property({type: Boolean}) disabled = false;
	// Whether the user will be able to edit the citation after opening it
	@property({type: Boolean}) isEditable = false;
	@property({type: Boolean}) isSidebarApiClosed = false;
	@property({type: Boolean}) showToolTip = false;

	static styles = [iconStyles];

	onClickCitation = () => {
		const myEvent = new CustomEvent<{annotationUuid: annotationUuid}>("pnClickCitationButton", {
			detail: {
				annotationUuid: this.annotation.uuid
			},
			bubbles:  true,
			composed: true
		});

		this.dispatchEvent(myEvent);
	};

	render() {
		const citationApproved = this.annotation.citation && this.annotation.citation.approved === true;

		const viewCitationOnly = citationApproved ?? !this.isEditable;

		let tooltipText = viewCitationOnly
			? "View Citation"
			: "Confirm Citation";

		// The Sidebar API is being used, but the sidebar is currently closed. The
		// user needs to open the sidebar themselves to see the citation.
		if (this.isSidebarApiClosed) {
			tooltipText = viewCitationOnly
				? "Open sidebar to view citation"
				: "Open sidebar to view or edit citation";
		}

		let icon = citationApproved
			? "citation-solid"
			: "citation-outline";

		if (this.disabled)
			icon += "-green";

		return html`
			<pn-icon-button
				class="js-aa-citation-btn"
				.disabled="${this.disabled}"
				icon="${icon}"
				.onClick="${this.onClickCitation}"
				.showToolTip="${this.showToolTip}"
				.tippyOptions="${{placement: "bottom"}}"
				.tooltipText="${tooltipText}"
			></pn-icon-button>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-citation-button": CitationButton;
	}
}
